/**
 * State used in rendering TableCellActions
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
